// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DropdownController from "./dropdown_controller"
import ModalController from "./modal_controller"
import TabsController from "./tabs_controller"
import AlertController from "./alert_controller"

application.register("dropdown", DropdownController)
application.register("modal", ModalController)
application.register("tabs", TabsController)
application.register("alert", AlertController)
